import React, { useEffect, useState } from 'react'
import { segsToMinutes } from '../../tools/format'

import "./ButtonBlocked.css"

const ButtonBlocked = ({ time, timeToWait, setTimeToWait, setDisableButton }) => {
    const [timeInSeconds, _] = useState(Number(time) * 60)

    useEffect(() => {
        const intervalo = setInterval(() => {
            const timeAnterior = JSON.parse(localStorage.getItem("expiracion"))
            const timeActual = Date.now();


            const diferenciaMs = timeActual - timeAnterior;
            const diferenciaSegundos = Math.floor(diferenciaMs / 1000);
            const faltaEsperar = timeInSeconds - diferenciaSegundos;

            if (faltaEsperar <= 0) {
                setDisableButton(false)
            } else {
                setTimeToWait(segsToMinutes(faltaEsperar))
            }

        }, 1000);
        return () => clearInterval(intervalo);
    }, [])
    return (
        <div>Reintentar en {" "}
            <span key={timeToWait} className="contador">
                {timeToWait}
            </span>
        </div>
    )
}

export default ButtonBlocked